module.exports = __webpack_public_path__ + "media/images/marketing_round-447d1644ced54955854ce403a14c7757.svg";